/* eslint-disable @typescript-eslint/no-explicit-any */
import { Pathname } from "./pathname";

export const PathnameGenerator = (name: string): string => Pathname.DASHBOARD_ONBOARDING + name;

const CRUD_ACTIONS = { ADD: 'add', VIEW: 'view', EDIT: 'edit' } as const;

type ModulePaths = Record<string, string>;

export const MAIN_MENU: ModulePaths = {
  SETTINGS: 'settings',
};

export const MODULES: ModulePaths = {
  SETTINGS: 'settings',
};

export const generateCrudPaths = (
  base: string,
  entity: string,
  prefix = '',
  keyPostfix = ''
) =>
  { 
    return Object.fromEntries(
    Object.entries(CRUD_ACTIONS).map(([key, action]) => {
      const isEditOrView = action === 'edit' || action === 'view';
      const id = (isEditOrView && MODULES[base]?.includes(':id')) ? `:${entity?.replace('-', "")}Id` : ':id'
      const routeParts = [prefix, MODULES[base]];
      if (isEditOrView) {
       routeParts.push(id, `${action}-${entity}`);
      } else {
        routeParts.push(`${action}-${entity}`);
      }

      return [
        `${key}_${keyPostfix.replace(/[^a-zA-Z0-9]/g, '_').toUpperCase()}`,
        `/${routeParts.filter(Boolean).join('/')}`,
      ];
    })
  );
}


export const generateModulePaths = (mainModule: keyof typeof MAIN_MENU, subModule: keyof typeof MODULES = '', entity: string, keyPostfix = '') => ({
  [subModule.replace(/[^a-zA-Z0-9]/g, '_').toUpperCase()]: `/${[MAIN_MENU[mainModule], MODULES[subModule]].filter(Boolean).join('/')}`,
  ...generateCrudPaths(subModule, entity, MAIN_MENU[mainModule], keyPostfix),
});

export const PathnameOnBoarding: Record<any, string> = {
  LANDING_PAGE: '/',
  LIST: '/list',
  FORMS: "/settings/forms",
};

